import { useMutation } from '@tanstack/react-query';

import { loginStart } from '../api';

export default function useLoginStart() {
  return useMutation(({ data }: { data: string }) => loginStart(data));
}
